import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import Image from "../components/image"
import styled from "styled-components"
import SEO from "../components/seo"
import ListContainer from "../components/listContainer"
import XLMIcon from "../images/xlm.png"
import OXTIcon from "../images/oxt.png"
import EOSIcon from "../images/eos.png"
import BATIcon from "../images/bat.png"
import BTCIcon from "../images/btc.png"
import LTCIcon from "../images/ltc.png"
import XTZIcon from "../images/xtz.png"
import SiteIcon from "../images/free.png"
import TWTIcon from "../images/twt.png"
import SweatcoinIcon from "../images/sweatcoin.png"
import BinanceLogo from "../images/binance.jpg"
import RobinhoodLogo from "../images/robinhood.jpg"
import JackpocketLogo from "../images/jackpocket.jpg"
import Prices from "../components/pricesBox"
import BraveBanner from "../components/braveBanner"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" image={SiteIcon} pathname="" article={false} />
    {/* <BraveBanner /> */}

    {/* <iframe
      title="Title"
      data-aa="1286143"
      src="//ad.a-ads.com/1286143?size=320x50"
      scrolling="no"
      style={{
        width: 320,
        height: 50,
        border: 0,
        padding: 0,
        overflow: "hidden",
        borderRadius: 5,
      }}
      allowtransparency="true"
    /> */}

    <HeaderContainer>
      <HeaderCenterContainer>
        <SiteTitle>Learn how to get free crypto!</SiteTitle>
        <SiteDe>
          We have made it easy for you to learn how to get free cryptocurrency!
        </SiteDe>
      </HeaderCenterContainer>
    </HeaderContainer>

    <BigAdd>
      <iframe
        title="BigAd"
        data-aa="1326309"
        src="//ad.a-ads.com/1326309?size=990x90"
        scrolling="no"
        style={{
          width: 990,
          height: 90,
          border: 0,
          padding: 0,
          overflow: "hidden",
          borderRadius: 5,
        }}
        allowtransparency="true"
      />
    </BigAdd>
    <SmallAdd>
      <iframe
        title="Title"
        data-aa="1323916"
        src="//ad.a-ads.com/1323916?size=320x50"
        scrolling="no"
        style={{
          width: 320,
          height: 50,
          border: 0,
          padding: 0,
          overflow: "hidden",
          borderRadius: 5,
        }}
        allowtransparency="true"
      />
    </SmallAdd>
    <Main>
      <LeftSide>
        <CatContainer id="crypto">
          <CatText>Free Cryptocurrency</CatText>
        </CatContainer>
        {/* <ListContainer
          Logo={TWTIcon}
          ImageAlt="TWT Logo"
          From="Trustwallet.com"
          Title="Trust Wallet"
          Ticker="TWT"
          Value=" 125+ TWT"
          Path="/crypto/trustwallet-twt-125"
        /> */}
        <ListContainer
          Logo={XTZIcon}
          ImageAlt="XTZ Logo"
          From="faucet.tezos.com"
          Title="Tezos"
          Ticker="XTZ"
          Value=" 1 XTZ"
          Path="/crypto/tezos-xtz-faucet"
        />
        <ListContainer
          Logo={BTCIcon}
          ImageAlt="BTC Logo"
          From="Coinbase.com"
          Title="Bitcoin"
          Ticker="BTC"
          Value=" $10"
          Path="/crypto/bitcoin-btc-$10"
        />
        <ListContainer
          Logo={XLMIcon}
          ImageAlt="XLM Logo"
          From="Coinbase.com"
          Title="Stellar"
          Ticker="XLM"
          Value=" $50"
          Path="/crypto/stellar-xlm-$50"
        />
        <ListContainer
          Logo={OXTIcon}
          ImageAlt="OXT Logo"
          From="Coinbase.com"
          Title="Orchid"
          Ticker="OXT"
          Value=" $52"
          Path="/crypto/orchid-oxt-$52"
        />
        <ListContainer
          Logo={EOSIcon}
          ImageAlt="EOS Logo"
          From="Coinbase.com"
          Title="EOS"
          Ticker="EOS"
          Value=" $50"
          Path="/crypto/eos-eos-$50"
        />
        <ListContainer
          Logo={BATIcon}
          ImageAlt="Brave Logo"
          From="BraveBrowser"
          Title="Basic Attention Token"
          Ticker="BAT"
          Value=" Unlimited"
          Path="/crypto/brave-browser"
        />
        {/* <ListContainer
          Logo={BATIcon}
          From="Coinbase.com"
          Title="Basic Attention Token"
          Ticker="BAT"
          Value="$20"
        /> */}
        <ListContainer
          Logo={BinanceLogo}
          ImageAlt="Binance Logo"
          From="Binance.us"
          Title="Binance.us"
          Ticker="Commission"
          Value=" 20% - 40%"
          Path="/crypto/binance-us-comm"
        />
        <ListContainer
          Logo={LTCIcon}
          ImageAlt="LTC Logo"
          From="Earncrypto.com"
          Title="Litecoin"
          Ticker="LTC"
          Value=" Unlimited"
          Path="/crypto/earncrypto"
        />
        {/* <CatContainer>
          <CatText>Free Stock</CatText>
        </CatContainer>
        <ListContainer
          Logo={RobinhoodLogo}
          From="Robinhood App"
          Title="Robinhood"
          Ticker="Any"
          Value="$2.50 - $200"
        />
        <CatContainer>
          <CatText>Free Money</CatText>
        </CatContainer>
        <ListContainer
          Logo={JackpocketLogo}
          From="Jackpocket App"
          Title="Jackpocket"
          Ticker="USD"
          Value="$10"
        />
        <ListContainer
          Logo={SweatcoinIcon}
          From="Sweatcoin App"
          Title="Sweatcoin"
          Ticker="SWC"
          Value=" Unlimited"
        /> */}
      </LeftSide>
      <Prices />
    </Main>
  </Layout>
)

export default IndexPage

const Main = styled.div`
  padding-top: 20px;
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  transition-delay: 0.05s;
  transition-duration: 0.3s;
  @media only screen and (min-width: 320px) and (max-width: 820px) {
    width: 100%;
    padding-top: 0px;
  }
`

const HeaderContainer = styled.div`
  background: linear-gradient(
    to bottom,
    rgba(17, 62, 180, 1),
    rgba(22, 82, 240, 1)
  );
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  transition-delay: 0.05s;
  transition-duration: 0.3s;
  // box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  @media only screen and (min-width: 320px) and (max-width: 820px) {
    height: 100%;
  }
`

const BigAdd = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  @media only screen and (min-width: 20px) and (max-width: 1100px) {
    display: none;
  }
`

const SmallAdd = styled.div`
  display: none;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  @media only screen and (min-width: 20px) and (max-width: 1100px) {
    display: flex;
  }
`

const HeaderCenterContainer = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  transition-delay: 0.05s;
  transition-duration: 0.3s;
  padding-top: 100px;
  padding-bottom: 140px;
  @media only screen and (min-width: 320px) and (max-width: 820px) {
    width: 90%;
    justify-content: center;
    align-items: flex-start;
    padding-top: 40px;
    padding-bottom: 40px;
  }
`

const LeftSide = styled.div`
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  transition-delay: 0.05s;
  transition-duration: 0.3s;
  @media only screen and (min-width: 320px) and (max-width: 820px) {
    width: 95%;
  }
`

const CatContainer = styled.div`
  background-color: rgba(22, 82, 240, 1);
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  display: flex;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2);
  padding-top: 10px;
  padding-bottom: 10px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  z-index: 10;
  @media only screen and (min-width: 320px) and (max-width: 820px) {
  }
`

const CatText = styled.h1`
  font-family: proxima-nova, helvetica neue, Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: 18px;
  color: white;
  margin-left: 15px;
  margin-bottom: 0px;
  letter-spacing: 0.075em;
`

const SiteTitle = styled.h1`
  text-shadow: 0 1px 24px rgba(0, 0, 0, 0.29);
  font-size: 40px;
  line-height: 40px;
  text-align: left;
  color: rgba(255, 255, 255, 1);
  font-weight: 700;
  transition-delay: 0.05s;
  transition-duration: 0.3s;
  @media only screen and (min-width: 320px) and (max-width: 820px) {
    font-size: 32px;
  }
`

const SiteDe = styled.h2`
  font-size: 28px;
  line-height: 38px;
  text-align: center;
  font-weight: 400;
  margin-top: 10px;
  margin-left: 10px;
  width: 55%;
  text-align: left;
  color: rgba(255, 255, 255, 0.8);
  transition-delay: 0.05s;
  transition-duration: 0.3s;
  @media only screen and (min-width: 320px) and (max-width: 820px) {
    font-size: 22px;
    width: 95%;
    margin-left: 0px;
    margin-top: 20px;
  }
`
